export enum QueueType {
  averageLengthInPeriod,
  maximumLengthInPeriod,
  instantaniousLengthAtEndOfPeriod
}



// WEBPACK FOOTER //
// ./src/app/models/enums/queuetype.ts